import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setCurrentStepAction, setIsValidFieldsAction, setValidateFieldsAction } from '../../store/navegationSteps/actions'

import {withRouter} from 'react-router-dom';
import NavigationButtons from './navigationButtons'
import { stepsFormGrupos } from '../../service/stepsService';

const makeSteps = ({currentNavegation} = {currentNavegation:{}}) =>
      stepsFormGrupos(currentNavegation.Grupos)

const mapStateToProps = (state) => ({
  navegation: state.navegationStepsReducer,
  steps:makeSteps(state.navegationStepsReducer)
})

const mapDispatchToProps = dispatch =>
bindActionCreators({ setCurrentStepAction, setValidateFieldsAction, setIsValidFieldsAction }, dispatch)

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(NavigationButtons))
